import { CentreConfigurationDto, configurationClient } from 'api/planning';
import { api } from '../api';

export const configurationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCentreConfiguration: builder.query<CentreConfigurationDto, { centreId: number }>({
      query: ({ centreId: _ }) => configurationClient.getCentreConfiguration(),
    }),
  }),
});

export const { useGetCentreConfigurationQuery } = configurationApi;
